var Marionette = require('backbone.marionette');
var moment = require('moment'); // For Date Time manipulations
const uuidV4 = require('uuid/v4');

var Dicts = require('../data/dicts');
var DocumentMetaDicts = require('../data/document-meta-dict');
var Constants = require('./constants');

var CommonUtils = Marionette.Object.extend({

        stringContains: function (str, fragment) {
            str = (str || '').toLowerCase();
            fragment = (fragment || '').toLowerCase();
            return str.indexOf(fragment) !== -1
        },

        stringDateToLong: function (format, stringValue) {
            return moment(stringValue, format).toDate().getTime();
        },

        longToDateTimeFormatted: function (uts, format) {
            return moment(uts).format(format);
        },

        dateToLong: function (d) {
            try {
                return Number(new Date(d).getTime());
            }
            catch (exp) {
                return 0;
            }
        },

        longToDateTimeFormattedInUtc: function (l, format) {
            console.log(l);
            //return moment(l).utcOffset(new Date().getTimezoneOffset()).format(format);

            var date = new Date(l);
            var utcDate = new Date();
            utcDate.setFullYear(date.getUTCFullYear());
            utcDate.setMonth(date.getUTCMonth());
            utcDate.setDate(date.getUTCDate());
            /*utcDate.setHours(date.getUTCHours());
            utcDate.setMinutes(date.getUTCMinutes());
            utcDate.setSeconds(date.getUTCSeconds());
            utcDate.setMilliseconds(date.getUTCMilliseconds());*/
            return moment(utcDate).format(format);
        },

        dateToLongInUtc: function (d) {
            try {
                var date = new Date(d);
                var utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()/*,
                    date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()*/);
                console.log(utc);
                console.log(Number(new Date(d).getTime()));
                return utc;
            }
            catch (exp) {
                return 0;
            }
        },

        getDateWithoutTime: function (dt) {
            return moment(dt).clone().startOf('day');
        },

        showSpinner: function (el) {
            if (typeof el === 'undefined')
                el = '.loader';
            $(el).show();
        },

        hideSpinner: function (el) {
            if (typeof el === 'undefined')
                el = '.loader';
            $(el).hide();
        },

        formatPerson: function (person) {
            var names = [];
            if (!_.isEmpty(person.lastName))
                names.push(person.lastName.toUpperCase());
            if (!_.isEmpty(person.firstName))
                names.push(person.firstName.toUpperCase());
            return names.join(", ");
        },

        userCanDo: function (userPermissions, userPermissionFilter, objectPermissions, objectPermissionFilter) {
            if (_.contains(userPermissions.userSystemRoles, 'ADMIN'))
                return true;

            var canDoFor = (userPermissions || []).userPermissions.filter(userPermissionFilter).map(function (permission) {
                return permission.permittedObjectId;
            });
            canDoFor.push(userPermissions.userId);

            var canDo = false;
            (objectPermissions || []).filter(objectPermissionFilter).forEach(function (permission) {
                if (permission.ownerId && permission.organizationId &&
                    canDoFor.indexOf(permission.ownerId) > -1 &&
                    canDoFor.indexOf(permission.organizationId) > -1) {
                    canDo = true;
                }

                if (permission.ownerId && !permission.organizationId &&
                    canDoFor.indexOf(permission.ownerId) > -1) {
                    canDo = true;
                }

                if (!permission.ownerId && permission.organizationId &&
                    canDoFor.indexOf(permission.organizationId) > -1) {
                    canDo = true;
                }
            });
            return canDo;
        },

        userCanDoWithDocument: function (userPermissions, userPermissionFilterFor, userPermissionFilterAll, objectPermissions, objectPermissionFilter) {
            if (_.contains(userPermissions.userSystemRoles, 'ADMIN'))
                return true;

            var canDoFor = (userPermissions || []).userPermissions.filter(userPermissionFilterFor).map(function (permission) {
                return permission.permittedObjectId;
            });
            canDoFor.push(userPermissions.userId);

            var canDoForAll = (userPermissions || []).userPermissions.filter(userPermissionFilterAll).map(function (permission) {
                return permission.permittedObjectId;
            });

            var canDo = false;
            (objectPermissions || []).filter(objectPermissionFilter).forEach(function (permission) {
                if (permission.ownerId && permission.organizationId &&
                    canDoFor.indexOf(permission.ownerId) > -1 &&
                    canDoFor.indexOf(permission.organizationId) > -1) {
                    canDo = true;
                }

                if (permission.ownerId && !permission.organizationId &&
                    canDoFor.indexOf(permission.ownerId) > -1) {
                    canDo = true;
                }

                if (!permission.ownerId && permission.organizationId &&
                    canDoFor.indexOf(permission.organizationId) > -1) {
                    canDo = true;
                }

                if (permission.organizationId && canDoForAll.indexOf(permission.organizationId) > -1)
                    canDo = true;
            });
            return canDo;
        },

        queryParamsToCollection: function (params) {
            var result = [];
            for (var param in params) {

                if (Array.isArray(params[param])) {

                    for (var ind in params[param]) {
                        result.push({key: param, value: params[param][ind]});
                    }

                } else {
                    result.push({key: param, value: params[param]})
                }
            }
            return result;
        },

        canUserChangeStatus: function (permissions, reviewer) {
            if (permissions.userSystemRoles && _.contains(permissions.userSystemRoles, 'ADMIN'))
                return true;

            var perms = permissions.userPermissions;
            if (reviewer.personId && !reviewer.organizationId) {

                if (permissions.userId == reviewer.personId)
                    return true;
                var found = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.personId && perm.canSign == true;
                });
                return typeof(found) != "undefined";
            }
            else if (!reviewer.personId && reviewer.organizationId) {

                var foundForOrganizationSignAll = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.organizationId && perm.canSignAll == true;
                });

                if (typeof(foundForOrganizationSignAll) != "undefined")
                    return true;

                var found = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.organizationId && perm.canSign == true;
                });
                return typeof(found) != "undefined";
            }
            else if (reviewer.personId && reviewer.organizationId) {

                var foundForOrganizationSignAll = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.organizationId && perm.canSignAll == true;
                });

                if (typeof(foundForOrganizationSignAll) != "undefined")
                    return true;

                var foundForPerson = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.personId && perm.canSign == true;
                });
                var foundForOrganization = _.find(perms, function (perm) {
                    return perm.permittedObjectId == reviewer.organizationId && perm.canSign == true;
                });

                return (typeof(foundForPerson) != "undefined" || permissions.userId == reviewer.personId)
                    && typeof(foundForOrganization) != "undefined";
            }

            return false;
        },

        getQueryParams: function () {
            var paramsTokens = window.location.hash.split("?");
            var params = {};
            if (paramsTokens.length > 1) {
                params = $.deparam(window.location.hash.replace(paramsTokens[0], '').replace('?', '')) || {};
            }
            return params;
        },

        isUrlWoExtraQueryParameters: function () {

            var queryParams = this.getQueryParams();
            return _.isEmpty(queryParams) ||
                (_.keys(queryParams).length == 2
                    && typeof queryParams["page-size"] != "undefined"
                    && typeof queryParams["page"] != "undefined")
        },

        redirectToUrlWoExtraQueryParameters: function () {

            var defaultParams = this.fillWithDefaultParams({});
            window.location.hash = this.getCleanBaseHash() + "?" + this.objectToQueryParams(defaultParams);
        },

        getDefaultListParams: function () {
            var params = this.getQueryParams();
            return this.fillWithDefaultParams(params);
        },

        fillWithDefaultParams: function (params) {
            params['page-size'] = params['page-size'] || Constants.pageCapacity;
            params.page = parseInt(params.page || Constants.pageInitialOrd, 10);
            return params;
        },

        getCleanBaseHash: function () {
            var paramsTokens = window.location.hash.split("?");
            return paramsTokens[0].replace('#', '');
        },

        objectToQueryParams: function (params) {
            var tokens = [];
            for (var i in params) {
                if (Array.isArray(params[i])) {
                    for (var j in params[i]) {
                        tokens.push(i + '=' + params[i][j]);
                    }
                } else {
                    tokens.push(i + '=' + params[i]);
                }
            }
            return tokens.join('&');
        },

        isParamExists: function (params, searchObject) {
            if (_.findWhere(params, searchObject))
                return true;
            else
                return false;
        },

        mergeCollectionParams: function (defaultCollectionParams, mergedCollectionParams) {
            var newParams = []
            mergedCollectionParams.forEach(function (param) {
                var existed = _.find(defaultCollectionParams, function (p) {
                    return param.key == p.key;
                })
                if (_.isUndefined(existed)) {
                    newParams.push(param)
                } else {
                    existed.value = param.value
                }
            });

            return defaultCollectionParams.concat(newParams)
        },

        delay: (function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })(),

        getDocumentStatus: function (key) {
            return Dicts.documentStatuses[key];
        },

        getReviewerStatus: function (key) {
            return Dicts.reviewerStatuses[key];
        },

        getIntention: function (key) {
            return Dicts.documentIntention[key];
        },

        getMedicationEventType: function (key) {
            return Dicts.medicationEventTypes[key];
        },

        getContactPriorities: function () {
            return Dicts.contactPriorities;
        },

        getContactTypes: function () {
            return Dicts.contactTypes;
        },

        personDataFromNpiData: function (npiData) {
            return {
                lastName: npiData.basic["last_name"],
                firstName: npiData.basic["first_name"],
                middleName: npiData.basic["middle_name"],
                gender: npiData.basic["gender"],
                address: this.buildLocationAddressFromNpiData(npiData)
            }
        },

        organizationDataFromNpiData: function (npiData) {
            return {
                name: npiData.basic["organization_name"],
                createdDT: (npiData["created_epoch"] ? new Number(npiData["created_epoch"]) * 1000 : undefined),
                address: this.buildLocationAddressFromNpiData(npiData)
            }
        },

        buildLocationAddressFromNpiData: function (npiData) {
            var locationAddresses = npiData.addresses.filter(function (address) {
                return address["address_purpose"] == 'LOCATION';
            });
            var locationAddress = locationAddresses[0];
            return {
                uuid: this.generatedUUID(),
                country: locationAddress["country_code"],
                state: locationAddress["state"],
                county: null,
                zip: locationAddress["postal_code"],
                town: locationAddress["city"],
                address: locationAddress["address_1"] + ' ' + locationAddress["address_2"],
                usage: 'WP',
                source: 'NPI'
            };
        },

        addressesAndContactsFromNpiData: function (npiData) {
            var that = this;
            var alreadyAddedContacts = [];
            var addresses = [];
            var contacts = [];

            npiData.addresses.forEach(function (address) {
                var addressToAdd = {
                    uuid: that.generatedUUID(),
                    country: address["country_code"],
                    state: address["state"],
                    county: null,
                    zip: address["postal_code"],
                    town: address["city"],
                    address: address["address_1"] + ' ' + address["address_2"],
                    usage: 'WP',
                    source: 'NPI'
                };
                addresses.push(addressToAdd);

                if (!_.isEmpty(address["fax_number"]) && alreadyAddedContacts.indexOf(address["fax_number"]) < 0) {
                    contacts.push({
                        data: address["fax_number"].replace(new RegExp('-', 'g'), ''),
                        type: 'FAX',
                        preferred: false,
                        addresses: [addressToAdd.uuid],
                        source: 'NPI'
                    });
                    alreadyAddedContacts.push(address["fax_number"]);
                } else if (alreadyAddedContacts.indexOf(address["fax_number"]) >= 0) {
                    contacts.filter(function (contact) {
                        return contact.data == address["fax_number"].replace(new RegExp('-', 'g'), '');
                    })[0].addresses.push(addressToAdd.uuid);
                }

                if (!_.isEmpty(address["telephone_number"]) && alreadyAddedContacts.indexOf(address["telephone_number"]) < 0) {
                    contacts.push({
                        data: address["telephone_number"].replace(new RegExp('-', 'g'), ''),
                        type: 'PHONE',
                        preferred: false,
                        addresses: [addressToAdd.uuid],
                        source: 'NPI'
                    });
                    alreadyAddedContacts.push(address["telephone_number"]);
                } else if (alreadyAddedContacts.indexOf(address["telephone_number"]) >= 0) {
                    contacts.filter(function (contact) {
                        return contact.data == address["telephone_number"].replace(new RegExp('-', 'g'), '');
                    })[0].addresses.push(addressToAdd.uuid);
                }
            });
            return {
                addresses: addresses,
                contacts: contacts
            };
        },

        generatePassword: function password_generator(len) {
            var length = (len) ? (len) : (10);
            var string = "abcdefghijklmnopqrstuvwxyz";
            var numeric = '0123456789';
            var password = "";
            var character = "";
            while (password.length < length) {
                entity1 = Math.ceil(string.length * Math.random() * Math.random());
                entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
                hold = string.charAt(entity1);
                hold = (entity1 % 2 == 0) ? (hold.toUpperCase()) : (hold);
                character += hold;
                character += numeric.charAt(entity2);
                password = character;
            }
            return password;
        },

        randomString: function (len) {
            var text = " ";
            var charset = "abcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < len; i++)
                text += charset.charAt(Math.floor(Math.random() * charset.length));

            return text;
        },

        generatedUUID: function () {
            return uuidV4();
        },

        splitToPair: function (text, separator) {
            return [text.substr(0, text.indexOf(separator)), text.substr(text.indexOf(separator) + 1)];
        },

        isValidEmail: function (email) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        },

        isValidNPI: function (npi) {
            return /\d{10}/.test(npi);
        },

        deepClone: function (obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        getHousingValues: function () {
            return Dicts.housingValues;
        },

        martialStatuses: function () {
            return Dicts.martialStatuses;
        },

        getDeterminationOfNeedRevised: function () {
            return Dicts.determinationOfNeedRevised;
        },

        extractContactValuesByType: function (contacts, type) {
            return contacts.filter(function (contact) {
                return contact.type == type;
            }).map(function (contact) {
                return contact.data;
            });
        },

        extractContactValuesByTypeAsString: function (contacts, type) {
            return this.extractContactValuesByType(contacts, type).join(', ');
        },

        getHoursValues: function () {
            return _.range(24);
        },

        getDaysValues: function () {
            return _.range(31);
        },

        getUpperCaseCharsList: function () {
            return _.map(_.range(26), function (i) {
                return String.fromCharCode(65 + i);
            });
        },

        normalizeContact: function (contact) {
            return contact.replace(new RegExp(' ', 'g'), '').replace(new RegExp('_', 'g'), '').replace(new RegExp('-', 'g'), '').replace(new RegExp('\\(', 'g'), '').replace(new RegExp('\\)', 'g'), '').replace(new RegExp('\\+', 'g'), '');
        },

        downloadFileWithPost: function (url, params) {
            var form = document.createElement('form');
            form.setAttribute('target', '_blank');
            form.setAttribute('action', url);
            form.setAttribute('method', 'post');
            document.body.appendChild(form);
            for (var i = 0; i < params.length; i++) {
                var par = params[i];
                if (_.isEmpty(par)) continue;
                var keyValue = par.split('=');
                var input = document.createElement('input');
                input.setAttribute('type', 'text');
                input.setAttribute('name', keyValue[0]);
                input.setAttribute('value', decodeURIComponent(keyValue[1]));
                form.appendChild(input);
            }
            form.submit();
            document.body.removeChild(form);
        },

        initialMeta: function () {
            return _.keys(DocumentMetaDicts.documentMetaFields).map(function (field) {
                return {
                    field: field,
                    related: '',
                    nodeRepresentation: '',
                    nameLocalizedString: '',
                    slotName: '',
                    codingScheme: '',
                    value: [''],
                    description: ''
                }
            });
        },

        getPredefinedMetaCodesOrCodeNames: function (key, index) {
            if (key === 'classCode' || key === 'typeCode')
                return DocumentMetaDicts.classCodesWithDisplayName.map(function (item) {
                    return item.split(';')[index];
                });
            else if (key === 'confidentialityCode')
                return DocumentMetaDicts.confidentialityCodesWithDisplayName.map(function (item) {
                    return item.split(';')[index];
                });
            else if (key === 'formatCode')
                return DocumentMetaDicts.formatCodesWithDisplayName.map(function (item) {
                    return item.split(';')[index];
                });
            else if (key === 'healthcareFacilityTypeCode')
                return DocumentMetaDicts.healthcareFacilityTypeCodesWithDisplayName.map(function (item) {
                    return item.split(';')[index];
                });
            else if (key === 'practiceSettingCode')
                return DocumentMetaDicts.practiceSettingCodesWithDisplayName.map(function (item) {
                    return item.split(';')[index];
                });
            else
                return [];
        },

        mergeObjectsLeft: function (leftObject, rightObject) {
            _.keys(rightObject).forEach(function (key) {
                leftObject[key] = rightObject[key];
            });
            return leftObject;
        },

        mergeObjectsRight: function (leftObject, rightObject) {
            _.keys(leftObject).forEach(function (key) {
                rightObject[key] = leftObject[key];
            });
            return rightObject;
        }

    })
;

module.exports = CommonUtils;


//////////////////
// WEBPACK FOOTER
// ./app/utils/common-utils.js
// module id = 189
// module chunks = 0